export default __webpack_public_path__ + "static/media/cy.c7e8ab5f.svg";